<template>
  <div
    class="p-card p-field p-px-3 p-pt-1 p-pb-4 p-mb-4"
    style="background-color: #fff;"
  >
    <div class="p-d-flex p-ai-center p-my-3 sub-title-content">
      <i class="pi pi-calendar p-mr-2"></i>
      <div class="p-mr-2">Calendario</div>
    </div>
    <div class="p-d-flex p-jc-center" style="overflow-x: scroll;">
      <Calendar class="calendar-ac" :inline="true" :locale="es">
        <template #date="slotProps">
          <div
            v-if="areThereEvents(slotProps.date)"
            class="p-d-flex p-jc-center event-day"
            v-tooltip.top="
              `${formatDateLite(slotProps.date)}
              ${textEvents(slotProps.date)}`
            "
          >
            {{ slotProps.date.day }}
          </div>
          <template v-else>{{ slotProps.date.day }}</template>
        </template>
      </Calendar>
    </div>
    <div class="p-d-flex p-ai-center sub-title-content">
      <i class="pi pi-calendar p-mr-2"></i>
      <div class="p-mr-2 p my-3">
        {{
          pageIndex === 3
            ? "Actividades de la unidad"
            : pageIndex === 2
            ? "Actividades del módulo"
            : "Eventos próximos"
        }}
      </div>
    </div>
    <div v-if="events <= 0">
      <div class="p py-1 p my-2 ">
        <div class="p-d-flex p-ai-center">
          <span>
            <p>No tienes eventos asignados</p>
          </span>
        </div>
      </div>
    </div>
    <div v-else v-for="event in events" :key="event.id">
      <div class="p py-1 p my-2 item-text" @click="goToEvent(event)">
        <div class="p-d-flex p-ai-center">
          <span>
            <i class="pi pi-circle-off"></i>
            {{ event.lesson_title }}
          </span>
        </div>
        <span class="p pl-3">{{ formatDate(event.start) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import * as moment from "moment";
import store from "@/store";
import Role from "@/utils/role";
export default {
  data() {
    return {
      es: {
        firstDayOfWeek: 0,
        dayNames: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "Julio",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        monthNamesShort: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        today: "Today",
        clear: "Clear",
        dateFormat: "mm/dd/yy",
        weekHeader: "Wk"
      }
    };
  },
  computed: {
    ...mapState(["events"]),
    pageIndex() {
      const index = this.$route.path.includes("mod/activity")
        ? 3
        : this.$route.path.includes("courses/modules/mod")
        ? 2
        : 1;
      return index;
    }
  },
  mounted() {
    this.getEvents();
  },
  watch: {
    pageIndex: {
      handler() {
        this.setEvents([]);
        this.getEvents();
      }
    }
  },
  methods: {
    ...mapMutations("navigation", ["setCurrentLesson"]),
    ...mapMutations(["setEvents"]),
    ...mapActions(["getUserEvents", "getModuleEvents", "getUnitEvents"]),
    formatDate(value) {
      return moment(value).format("dddd, D MMMM, HH:mm");
    },
    formatDateLite(value) {
      return moment(value).format("dddd, D MMMM");
    },
    areThereEvents(date) {
      const i = this.events.findIndex(e =>
        this.eventDateEqualsCalendarDate(e, date)
      );
      return i !== -1;
    },
    textEvents(date) {
      const result = this.events.filter(e =>
        this.eventDateEqualsCalendarDate(e, date)
      );
      let textEvents = ``;
      for (const event of result) {
        textEvents += `- ${event.lesson_title}\n`;
      }
      return textEvents;
    },
    eventDateEqualsCalendarDate(eDate, cDate) {
      return (
        moment(eDate.start).format("D") === `${cDate.day}` &&
        moment(eDate.start).format("M") === `${cDate.month + 1}`
      );
    },
    goToEvent(event) {
      this.setCurrentLesson({ id: event.lesson_id, unit_id: event.unit_id });
      if (this.pageIndex !== 3 && store.state.role === Role.STUDENT) {
        this.$router.push({ name: "LessonDetail" });
      }
    },
    getEvents() {
      switch (this.pageIndex) {
        case 1:
          this.getUserEvents();
          break;
        case 2:
          this.getModuleEvents();
          break;
        case 3:
          this.getUnitEvents();
          break;
        default:
      }
    }
  }
};
</script>

<style>
.sub-title-content > * {
  font-size: 22px;
}
.item-text {
  font-size: 14px;
  letter-spacing: 0.5px;
  cursor: pointer;
}
.item-text:hover {
  color: var(--institution_accent_color);
  filter: brightness(0.7);
}

.calendar-ac .p-datepicker {
  padding: 0 !important;
  border: none;
}
.p-datepicker table td > span .event-day {
  background-color: var(--institution_accent_color);
  color: #fff;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Events.vue